import { TopBar } from '@/layouts/TopBar';
import Paths from '@/routes/paths';
import { JButton } from '@atoms/JButton';
import { IconSize } from '@constants';
import EnterprisesList from '@enterprise/components/EnterprisesList';
import CreateEnterpriseProvider from '@enterprise/contexts/createEnterpriseContext';
import useEnterprises from '@enterprise/hooks/useEnterprises';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const EnterprisesPage = () => {
  const { t } = useTranslation();
  const { enterprisesCount } = useEnterprises();
  const navigate = useNavigate();
  return (
    <CreateEnterpriseProvider>
      <TopBar title={t('ENTERPRISES')} count={enterprisesCount}>
        <JButton
          data-qa="add-enterprise-button"
          variant="contained"
          color="secondary"
          onClick={() => navigate(Paths.CreateEnterprise)}
          startIcon={<PlusIcon color="#FFF" height={IconSize.buttonIcon} />}
        >
          {t('NEW_ENTERPRISE')}
        </JButton>
      </TopBar>
      <Box m={2}>
        <EnterprisesList />
      </Box>
    </CreateEnterpriseProvider>
  );
};

export default EnterprisesPage;
